import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { BRAND } from "@/constants/content";
import { Mail } from "lucide-react";

const linkCls = "text-sm text-slate-300 hover:text-white transition-colors";

const Footer = () => (
  <footer className="relative bg-[hsl(var(--charcoal-900))] text-white overflow-hidden">
    <div className="aurora opacity-40" aria-hidden />
    <div className="grain" aria-hidden />

    <div className="container-x relative z-10 pt-20 pb-10">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">

        {/* Brand */}
        <div>
          <Logo variant="dark" height={40} />

          <p className="mt-4 text-sm text-slate-300 max-w-sm">
            The BoostF eCommerce Launch Marathon is a practical, beginner-first
            program that walks you from an empty screen to a live Shopify store
            with real orders.
          </p>

          <a
            href={`mailto:${BRAND.supportEmail}`}
            className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
          >
            <Mail className="w-4 h-4" />
            {BRAND.supportEmail}
          </a>
        </div>

        {/* Quick Links */}
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 font-mono mb-3">
            Quick Links
          </div>

          <ul className="space-y-2">
            <li><a className={linkCls} href="#roadmap">Roadmap</a></li>
            <li><a className={linkCls} href="#mentor">Mentor</a></li>
            <li><a className={linkCls} href="#results">Results</a></li>
            <li><a className={linkCls} href="#faq">FAQ</a></li>
            <li><a className={linkCls} href="#reserve">Reserve My Seat</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 font-mono mb-3">
            Legal
          </div>

          <ul className="space-y-2">
            <li>
              <Link className={linkCls} to="/privacy-policy">
                Privacy Policy
              </Link>
            </li>

            <li>
              <Link className={linkCls} to="/terms">
                Terms &amp; Conditions
              </Link>
            </li>

            <li>
              <Link className={linkCls} to="/refund-policy">
                Refund Policy
              </Link>
            </li>

            <li>
              <a
                className={linkCls}
                href={`mailto:${BRAND.supportEmail}`}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-400">
        <div>
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </div>

        <div className="font-mono uppercase tracking-widest">
          Build. Launch. Scale.
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;